module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    attrs: {
      "id": "titleName"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#00A5D5"
    }
  }, [_vm._v(_vm._s(_vm.secTitle))]), _vm._v(" "), (_vm.content != '') ? _c('span', [_vm._v("（" + _vm._s(_vm.content) + "）")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "orderUpload"
  }, _vm._l((_vm.list), function(item, i) {
    return _c('el-upload', {
      key: i,
      class: ("upload-" + i),
      attrs: {
        "drag": "",
        "action": "",
        "show-file-list": false,
        "before-upload": _vm.handleChange,
        "http-request": _vm.uploadFile,
        "data": {
          objectType: _vm.dataType,
          objectTag: '',
          index: i
        },
        "auto-upload": true
      }
    }, [(_vm.dataList[i]) ? _c('img', {
      staticClass: "avatar",
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": _vm.dataList[i]
      }
    }) : _c('div', [_c('i', {
      staticClass: "el-icon-plus uploadIcon"
    }), _vm._v(" "), _c('div', {
      staticClass: "el-upload__text"
    }, [_c('em', [_vm._v(_vm._s(item.label))])])])])
  }), 1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "example"
    },
    on: {
      "click": function($event) {
        _vm.isShow = !_vm.isShow
      }
    }
  }, [_vm._v("示例\n    ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "item"
  }, [_c('div', {
    staticClass: "example"
  }, [_c('el-image', {
    staticClass: "boneToothImg",
    attrs: {
      "src": _vm.list[0].imgUrl
    }
  }), _vm._v(" "), _c('el-image', {
    staticClass: "boneImg",
    attrs: {
      "src": _vm.list[1].imgUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "copyright",
    attrs: {
      "src": "/static/images/orthodontics/smiling-orthodontics.jpg"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3562888c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/boneUploadImg.vue
// module id = 612
// module chunks = 0